import Echo from "laravel-echo"

window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.pusher_key,
    cluster: 'eu',
    encrypted: true,
});

if($('[data-update-games=true]').length){
    window.Echo.channel('competition.'+$('[data-update-games=true]').data('competition')+'.games_update')
        .listen('.competition.game.update', (e) => {
            $.ajax({
                url:$('[data-update-games=true]').data('url'),
                type:'GET',
                success:function(json){
                    $('[data-update-games=true]').replaceWith($(json).find('[data-update-games=true]'));
                    $('[data-toggle="table"]').bootstrapTable({
                        pagination:true,
                        search:true,
                        paginationLoop:false
                    });
                }
            });
        });
}
